import Axios from "axios";
import { LOGIN, LOGOUT, SOFT_LOGOUT, CHECK, SET_GUEST } from "./mutation-types";
import { AuthState, GuestUser } from "./state";
import { SHARE_EMAIL_CONSENT, TERMS_CONDITION_CONSENT } from "@/constants";

export default {
    [CHECK](state: AuthState) {
        if (localStorage.getItem("stqr_token")) {
            state.authenticated = true;
        }
        const isGueset = localStorage.getItem("isGuest");
        state.isGuest = isGueset ? JSON.parse(isGueset) : false;
        state.guest = JSON.parse(localStorage.getItem("guest"));
    },

    [LOGIN](
        state: AuthState,
        sessionData: {
            session: string;
            id: number;
            remindsMe: boolean;
            isGoogleAccount?: boolean;
            accountCreated?: boolean;
            stqrToken: string;
            isGuest: boolean;
        }
    ) {
        localStorage.setItem("stqr_token", sessionData.stqrToken);
        // store  uid in local storage or cookie only if user consents
        if (sessionData.remindsMe && !sessionData.isGuest) {
            localStorage.setItem("stqr_uid", sessionData.id.toString());
        }
        if(sessionData.isGuest){
            localStorage.setItem("guest_uid", sessionData.id.toString());
        }

        // state.didSignUp = sessionData.accountCreated || false;
        state.authenticated = true;
        state.isGuest = sessionData.isGuest || false;
        // state.userId = sessionData.userId;
        // state.sessionToken = sessionData.session;
        // state.isGoogleAccount = sessionData.isGoogleAccount || false;
    },

    [SET_GUEST](state: AuthState, guest: GuestUser){
        state.guest = guest;
        localStorage.setItem("guest", JSON.stringify(guest));
    },

    [LOGOUT](state: AuthState) {
        localStorage.removeItem("stqr_token");
        localStorage.removeItem("stqr_uid");
        localStorage.removeItem("guest");
        localStorage.removeItem("isGuest");
        localStorage.removeItem(TERMS_CONDITION_CONSENT);
        localStorage.removeItem(SHARE_EMAIL_CONSENT);

        state.authenticated = false;
        state.userId = "";
        state.sessionToken = "";

        delete Axios.defaults.headers.common.Authorization;
    },

    // Logout but do not clear storage. Used by qrcodes with "NO_ACCOUNT"
    [SOFT_LOGOUT](state: AuthState) {
        state.authenticated = false;
        state.userId = "";
        state.sessionToken = "";

        delete Axios.defaults.headers.common.Authorization;
    }
};
